import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const LocalStorageKeys = {
  preferredLanguage: 'preferredLanguage',
  darkMode: 'themeDarkMode',
} as const;

export type LocalStorageKey = (typeof LocalStorageKeys)[keyof typeof LocalStorageKeys];

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  readonly #platformId = inject(PLATFORM_ID);

  public get(key: LocalStorageKey): string | null {
    if (!isPlatformBrowser(this.#platformId)) {
      return null;
    }
    return localStorage.getItem(key);
  }

  public set(key: LocalStorageKey, value: string): void {
    if (!isPlatformBrowser(this.#platformId)) {
      return;
    }
    localStorage.setItem(key, value);
  }

  public remove(key: LocalStorageKey): void {
    if (!isPlatformBrowser(this.#platformId)) {
      return;
    }
    localStorage.removeItem(key);
  }
}
